import featuredImage from "assets/images/resource/staff-solutions-5.jpg";

const weDOSectionStaffSol = {
  title: "I. Human Capacity Development – Learning and Development Programmes",
  title2: "II. Human Capital Consulting Services",
  featuredImage,
  text: "",
  barTitle: "HUMAN CAPITAL SOLUTIONS",
  barPercent: 70,
  HCDLDP: [
    {
      id: 1,
      title: "2 Days Business Presentation Skills Development Workshop ",
      text: "Human Capacity Development – Learning and Development Programmes",
    },
    {
      id: 2,
      title: "1 Day Communication Skills and e-communications Training",
      text: "Human Capacity Development – Learning and Development Programmes",
    },
    {
      id: 3,
      title: "Managing Performance and Teams Managers' Training",
      text: "Human Capacity Development – Learning and Development Programmes",
    }, ,
    {
      id: 4,
      title: "Professional Coaching for Developing Talent",
      text: "Human Capacity Development – Learning and Development Programmes",
    }, ,
    {
      id: 5,
      title: "Team Effectiveness & Development Programme",
      text: "Human Capacity Development – Learning and Development Programmes",
    },
    {
      id: 6,
      title: "Leadership Coaching & Development",
      text: "Human Capacity Development – Learning and Development Programmes",
    },
    {
      id: 7,
      title: "Skills Development Planning & Learning",
      text: "Human Capacity Development – Learning and Development Programmes",
    },
    {
      id: 8,
      title: "Other Customised Human Capacity Development Programmes (Training & Upskilling).",
      text: "Human Capacity Development – Learning and Development Programmes",
    }
  ],
  HCCS: [
    {
      id: 1,
      title: "Organisation Diagnosis",
      text: "Human Capital Consulting Services",
    },
    {
      id: 2,
      title: "Culture Transformation",
      text: "Human Capital Consulting Services",
    },
    {
      id: 3,
      title: "Talent Management Strategies (Attraction, Onboarding Development & Retention, incl. Succession Planning)",
      text: "Human Capital Consulting Services",
    }, ,
    {
      id: 4,
      title: "Psychometric Assessments and Psychological Evaluations",
      text: "Human Capital Consulting Services",
    }, ,
    {
      id: 5,
      title: "Restructuring, Organisation Design, Renewal & Transformation",
      text: "Human Capital Consulting Services",
    },
    {
      id: 6,
      title: "Employment Equity Reporting (in South Africa)",
      text: "Human Capital Consulting Services",
    },
    {
      id: 7,
      title: "Leadership Strategy Formulation & Implementation",
      text: "Human Capital Consulting Services",
    },
    {
      id: 8,
      title: "Employment and Industrial Relations (Disciplinary Hearing Processes & CCMA)",
      text: "Human Capital Consulting Services",
    }, {
      id: 9,
      title: "Employee Experience and Systems Design.",
      text: "Human Capital Consulting Services",
    }
  ],
};

export default weDOSectionStaffSol;
